import SingleSiteMap from './SingleSiteMap'

export default SingleSiteMap
